// extracted by mini-css-extract-plugin
var _1 = "CarouselThumbnailBar-module__animateUploadProgressBarWidth--Bk28a";
var _2 = "CarouselThumbnailBar-module__animatedBackground--tUuqh";
var _3 = "CarouselThumbnailBar-module__container--HJUfI";
var _4 = "CarouselThumbnailBar-module__isDraggingOver--S6ZbR";
var _5 = "CarouselThumbnailBar-module__isSelected--e6XKG";
var _6 = "CarouselThumbnailBar-module__item--ZzBIB";
var _7 = "CarouselThumbnailBar-module__thumbnailBarScrollingContainer--X248j";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "isDraggingOver", _5 as "isSelected", _6 as "item", _7 as "thumbnailBarScrollingContainer" }
